import { Injectable, inject } from '@angular/core';
import { components, operations } from 'src/app/core/services/api/generated/ix-api.types';
import { IxRestApi } from 'src/app/core/services/api/ix-rest-api';
import { ExportToExcelService } from '../core/services/export-to-excel.service';

type PrmPackageDto = components['schemas']['PrmPackageDto'];
export type PrmDisciplineMappingDto = components['schemas']['PrmDisciplineMappingDto'];
export type PrmDisciplineErrorType = PrmDisciplineMappingDto['errorType'];
export type PrmDisciplineDto = components['schemas']['PrmDisciplineDto'];
export type PrmDataDto = components['schemas']['PrmDataDto'];

export interface PrmPackageWithError extends PrmPackageDto {
  hasError?: boolean;
}

@Injectable()
export class PrmApiService {
  readonly #ixRestApi = inject(IxRestApi);
  readonly #exportToExcelService = inject(ExportToExcelService);

  getPrmData(path: operations['getPrmData']['parameters']['path']) {
    return this.#ixRestApi.get({ pathname: '/api/projects/{projectId}/prm/data', options: { path } });
  }

  allActivitiesExport(projectId: number) {
    const resourceurl = `/api/projects/${projectId}/prm/excelexport`;
    return this.#exportToExcelService.export(resourceurl);
  }
}
